import type { GroupBase, OptionProps } from 'react-select';
import Checkbox from '@/app/components/Checkbox';
import type { OptionType } from '../../../MultiSelect/types';

export const OptionWithCheckBoxRight = <T extends OptionType>(props: OptionProps<T, true, GroupBase<T>>) => {
  const { data, isSelected, innerRef, innerProps } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="px-3 py-2 flex items-center justify-start gap-2 cursor-pointer hover:bg-gray-100"
    >
      {data.icon && <div className="text-xl">{data.icon}</div>}
      <div className="w-full">
        <div className="text-body-responsive text-black">{data.label}</div>
        {data.description && <div className="text-body-small text-gray-500">{data.description}</div>}
      </div>
      <Checkbox checked={isSelected} readOnly />
    </div>
  );
};
